import { z } from "zod"

export const AgencyVisitUserSchema = z.object({
  id: z.number(),
  fullName: z.string(),
})

export const AgencyVisitMediaSchema = z.object({
  id: z.number(),
  real_name: z.string(),
  url: z.string(),
  mime_type: z.string(),
  mime_class: z.string(),
})

export const AgencyVisitSchema = z.object({
  id: z.number(),
  agency_id: z.number(),
  agency_name: z.string(),
  date: z.string(),
  reason: z.string(),
  status: z.number(),
  rating: z.number().nullable(),
  created_at: z.number(),
  visited_at: z.number().nullable(),
  users: z.array(AgencyVisitUserSchema),
})

export const AgencyVisitDetailSchema = AgencyVisitSchema.extend({
  agency_appearance: z.string().nullable(),
  technical_aspects: z.string().nullable(),
  human_aspects: z.string().nullable(),
  comercial_aspects: z.string().nullable(),
  summary: z.string().nullable(),
  next_steps: z.string().nullable(),
  internal_notes: z.string().nullable(),
  notification_users: z.array(AgencyVisitUserSchema),
  medias: z.array(AgencyVisitMediaSchema),
})

export const AgencyVisitFormSchema = z.object({
  agency_id: z.number(),
  date: z.string(),
  reason: z.string().min(1).max(255),
  status: z.number().default(5),
  rating: z.number().nullable().default(null),
  agency_appearance: z.string().nullable().default(null),
  technical_aspects: z.string().nullable().default(null),
  human_aspects: z.string().nullable().default(null),
  comercial_aspects: z.string().nullable().default(null),
  summary: z.string().nullable().default(null),
  next_steps: z.string().nullable().default(null),
  internal_notes: z.string().nullable().default(null),
  users: z.array(z.number()).default([]),
  notification_users: z.array(z.number()).default([]),
})

export type AgencyVisit = z.infer<typeof AgencyVisitSchema>
export type AgencyVisitDetail = z.infer<typeof AgencyVisitDetailSchema>
export type AgencyVisitFormValues = z.infer<typeof AgencyVisitFormSchema>
export type AgencyVisitUser = z.infer<typeof AgencyVisitUserSchema>
export type AgencyVisitMedia = z.infer<typeof AgencyVisitMediaSchema>
